(function () {
  const gallery = document.getElementById('product-images');
  if (!gallery) return;

  const track = gallery.querySelector('[data-gallery-track]');
  const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  const thumbsRow = gallery.querySelector('.product-gallery__thumbs');
  if (!track || !slides.length) return;

  let current = Number(gallery.dataset.activeIndex) || 0;

  function setActive(index, scrollThumbs = true) {
    current = index;
    slides.forEach((slide, i) => slide.classList.toggle('active', i === index));
    thumbs.forEach((thumb, i) => {
      const isActive = i === index;
      thumb.classList.toggle('active', isActive);
      if (isActive) {
        thumb.setAttribute('aria-current', 'true');
        if (thumbsRow && scrollThumbs) {
          const left = thumb.offsetLeft - (thumbsRow.clientWidth - thumb.clientWidth) / 2;
          thumbsRow.scrollTo({ left, behavior: 'smooth' });
        }
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  }

  function goTo(index, behavior = 'smooth', scrollThumbs = true) {
    const target = (index + slides.length) % slides.length;
    track.scrollTo({ left: slides[target].offsetLeft, behavior });
    setActive(target, scrollThumbs);
  }

  // Keep thumbnails in sync when the user swipes the main image
  let scrollTimer;
  track.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      if (index !== current && slides[index]) setActive(index);
    }, 80);
  }, { passive: true });

  const canHover = window.matchMedia('(hover: hover)').matches;
  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => goTo(i));
    if (canHover) thumb.addEventListener('mouseenter', () => { if (i !== current) goTo(i, 'instant', false); });
  });
  gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => goTo(current - 1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => goTo(current + 1));

  // variants.js dispatches the selected variant: use its assigned image, else an image whose alt matches
  gallery.addEventListener('gallery:select-variant', (event) => {
    const { mediaId, title } = event.detail;
    let index = slides.findIndex((slide) => mediaId && slide.dataset.galleryMediaId === String(mediaId));
    if (index === -1) index = slides.findIndex((slide) => slide.querySelector('img')?.alt === title);
    if (index > -1 && index !== current) goTo(index);
  });

  if (current > 0) goTo(current, 'instant');
  window.addEventListener('resize', () => goTo(current, 'instant'));

  // Zoom dialog
  const dialog = document.getElementById('product-zoom-dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const dialogImg = dialog.querySelector('.product-zoom-dialog__img');
  let zoomIndex = 0;

  dialog.classList.toggle('is-single', slides.length < 2);

  function showZoom(index) {
    zoomIndex = (index + slides.length) % slides.length;
    const slide = slides[zoomIndex];
    dialog.classList.remove('is-zoomed');
    dialogImg.src = slide.dataset.zoomSrc;
    dialogImg.alt = slide.querySelector('img')?.alt || '';
  }

  slides.forEach((slide, i) => slide.addEventListener('click', () => {
    showZoom(i);
    dialog.showModal();
  }));

  dialog.querySelector('[data-zoom-close]')?.addEventListener('click', () => dialog.close());
  dialog.querySelector('[data-zoom-prev]')?.addEventListener('click', () => showZoom(zoomIndex - 1));
  dialog.querySelector('[data-zoom-next]')?.addEventListener('click', () => showZoom(zoomIndex + 1));
  dialogImg.addEventListener('click', () => dialog.classList.toggle('is-zoomed'));

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') showZoom(zoomIndex - 1);
    if (event.key === 'ArrowRight') showZoom(zoomIndex + 1);
  });

  // Sync the page gallery to whatever image was last viewed in the dialog
  dialog.addEventListener('close', () => goTo(zoomIndex, 'instant'));
})();
